import { StyleModule, Styles } from "./style-module";


export
{
    StyleModule,
    Styles
};

